import styled from "styled-components";
import { EVENT_PAGE_MIN_WIDTH } from "./layout-constants";

export const EventPageWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 44px 30px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-height: 0;
`;

export const EventPageHeader = styled.div`
  flex-shrink: 0;
`;

export const EventContentScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 0;
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
`;

export const EventContentBody = styled.div`
  width: 100%;
  min-width: ${EVENT_PAGE_MIN_WIDTH}px;
  min-height: 100%;
  box-sizing: border-box;
`;

export const EventPaginationBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 8px;

  > div {
    position: static;
    left: auto;
    transform: none;
    margin-top: 0;
  }
`;
